import { Component, OnInit, Input, Injectable, Inject, ViewChild, Output } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { MatPaginatorIntl } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { Response } from '@angular/http';

import 'rxjs/add/operator/toPromise';
import { EnvironmentProvider } from '../../core/browser-providers';
import { BackendService } from '../../core/backend.service';
import { Environment } from '../../../environments/enviroment.model';
import { UpdateEventService } from '../../shared-services/update-event.service';
import { MediaService } from '../../shared-services/media.service';
import { Subscription } from 'rxjs/Subscription';
import { SearchInputComponent } from '../../shared-components/search-input/search-input.component';
import { Cliente } from '../cliente.model';
import { EstadoCliente } from '../estadoCliente.model';
import { SecurityService } from '../../security/security.service';


enum ClienteEstadoLastLogin {
  ultimaSemana = 1,
  masUnaSemana = 2,
  masDosSemanas = 3
}

interface Filters {
  name: string;
  page: number;
  size: number;
  email?: string;
  search?: string;
  sort?: string;
}

interface Page {
  pageIndex: number;
  pageSize: number;
}

@Component({
  selector: 'app-clientes-aprobados-list',
  templateUrl: './clientes-aprobados-list.component.html',
  styleUrls: ['./clientes-aprobados-list.component.scss']
})
export class ClientesAprobadosListComponent implements OnInit {

  EstadoCliente = new EstadoCliente();

  private filters: Filters = {
    name: undefined,
    page: 0,
    size: 50,
    sort: 'created,desc'
  };

  columns = [
    { name: 'username',  label: 'Nombre de usuario' },
    { name: 'nombre',  label: 'Nombre' },
    { name: 'apellidos',  label: 'Apellido' }
  ];

  public showFilters = true;
  isMobile: boolean;

  @ViewChild(SearchInputComponent)
  private searchComponent: SearchInputComponent;

  private getNewPage = new Subject<Filters>();

  public totalItems: number;

  roleFiltersActive = false;
  mostrarResumen = false;
  isLoading = false;

  filtersLoaded = false;
  subscriptions: Subscription[] = [];

  clientesList = this.backendService.newSubjectWithoutDistinct<Filters>()
  .switchMap(filters => {
    const usersPromise = this.backendService.get(Cliente, Cliente.path + 'aprobados', filters).toPromise();
    return (async () => {
      this.isLoading = true;
      try {
        const permissions = await usersPromise;
        return permissions;
      } catch (error) {
        return [];
      }
      finally {
        this.isLoading = false;
        this.roleFiltersActive = !(this.filters.search === '' || this.filters.search === undefined);
      }
    })();
  }).share() as Observer<Filters> & Observable<Cliente[]>;

  constructor(
    @Inject(EnvironmentProvider) env: Environment,
    private route: ActivatedRoute,
    private backendService: BackendService,
    private paginatorsLabels: MatPaginatorIntl,
    public router: Router,
    protected updateEventService: UpdateEventService,
    private mediaService: MediaService,
    public securityService: SecurityService
  ) {
  }

  ngOnInit() {
    this.showFilters = true;
    this.filtersLoaded = true;

    this.subscriptions.push(this.mediaService.isMobile.subscribe(isMobile => {
      this.isMobile = isMobile;
      this.showFilters = !this.isMobile;
    }));

    this.paginatorsLabels.itemsPerPageLabel = 'Filas por página:';

    this.clientesList.subscribe(t => {
      this.isLoading = false;
      this.totalItems = t['totalItems'];
    });

    this.refreshRoleList();
  }

  refreshRoleList() {
    this.clientesList.next(this.getFilters());
  }

  getDefaultFilters() {
    this.filters = {
      name : undefined,
      page: 0,
      size: 50,
    };
  }

  getFilters() {
    return this.filters;
  }

  // Seteo de filtros
  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  onPageChange(page: Page) {
    this.filters.page = page.pageIndex;
    this.filters.size = page.pageSize;
    this.refreshRoleList();
  }

  onSearch(searchText) {
    this.filters.search = 'name:' + searchText;
    this.refreshRoleList();
  }

  clearSearch() {
    this.searchComponent.searchBox.value = '';
    this.refreshRoleList();
  }

  getData(response: Response) {
    const data = response.json();
    if (response.ok) { return data; }
    throw data['hydra:description'] || data['message'];
  }

  displayFilters(boolean: boolean) {
    this.showFilters = boolean;
  }

  onFiltersChanged(event) {
    this.refreshRoleList();
  }

  onVerSaldos(cliente: Cliente) {
    this.router.navigate(['/clientes/ver-saldos', cliente.id]);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/clientes-aprobados-list/clientes-aprobados-list.component.ts